<template>
  <div 
    class="notification"
    :class="{ 'notification-active': notificationActive }"
  >
    <div 
      class="notification-block"
      :class="{ 'notification-block__active': notificationActive }"
    >
      <div 
        class="notification-close pro-icon-close1"
        @click="closeNotification"
      >
      </div>
      <div class="notification-title">
        Уведомления
      </div>
      <div class="notification-list">
        <div 
          class="notification-item"
          :class="{ 'notification-item__road': !notification.isRead } "
          v-for="notification in notifications.list"
          :key="notification.id"
        >
          <div class="notification-item__date">
            {{ new Date( notification.date ) | dateFormat('hh:mm DD.MM.YYYY')  }}
          </div>
          <div class="notification-item__title">
            <router-link 
              :to="$i18nRoute({ name: 'notification-view', params: { id:  notification.id }})"
              target="_blank"
            >
              {{ notification.title }}
            </router-link>
          </div>
        </div>
      </div>

      <div 
        class="notification-pagination"
        @click="fetchData"
      >
        <span >
          {{ ('Получить еще') }}
        </span>
        <v-progress-circular 
          indeterminate size="24" 
          v-if="loading"
        />
      </div>
    </div>  
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  export default {
    name: 'Notification',

    data () {
      return {
        loading: false
      }
    },

    props: {
      notifications: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters({
          notificationActive: 'getNotificationActive' 
        })
    },

    methods: {
      ...mapMutations(['setLoading']),
      closeNotification () {
        this.$store.dispatch('notificationActive', false)
      },
      
      fetchData() {
        this.loading = true
        this.$store.dispatch('notifications').then(() => {
          this.page++
          this.loading = false
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .notification {
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: rgb(84,84,84, 0.5);
    z-index: 90;
    top: 0;
    left: 0;
    display: none;
    transition: all 0.5s ease 0s;

    &-active {
      display: block;
    }
    

    &-block {
      position: fixed;
      background: #fff;
      height: 100vh;
      right: -600px;
      top: 0;
      width: 600px;
      transition: all 0.5s ease 0s;
      padding: 20px;
      box-shadow: 0 8px 10px rgba(54, 94, 117, .3), 0 0 0 0 rgba(249, 92, 24, .2), 0 0 0 0 rgba(249, 92, 24, .2);


      &__active {
        right: 0px;
      }
    }

    &-pagination {
      margin-top: 40px;
      cursor: pointer;
      display: flex;

      span {
        margin-right: 10px;
        border-bottom: 1px solid silver;
      }
    }

    &-close {
      padding: 10px;
      display: flex;
      align-items: right;
      justify-content: right;
    }

    &-title {
      font-size: 25px;
      font-weight: 600;
      padding-bottom: 20px;
    }

    &-item {
      font-weight: 500;
      padding: 20px 0;
      border-bottom: 2px solid silver;

      &__road {
        font-weight: 600;
      }

      &__title {
        padding-top: 10px;
        cursor: pointer;
      }
    }

    &-close {
      cursor: pointer;
    }

  }
</style>